import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  titleWrapper: {
    textDecoration: "none",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    flexBasis: "100%",
    flexGrow: 0,
    marginTop: 20,
    marginRight: 5,
    marginBottom: 10,
    paddingBottom: 15,
    borderBottom: `1px solid ${colour.grey[500]}`
  },
  editWrapper: {
    borderBottom: `1px solid ${colour.grey[500]}`,
    paddingBottom: 10
  },
  edit: {
    color: colour.brand.blue,
    textDecoration: "underline",
    display: "flex",
    fontWeight: 600
  },
  editImg: {
    marginRight: 10
  },
  textContainer: {
    flexGrow: 2
  },
  applianceTitle: {
    flex: 1,
    fontSize: 24,
    fontWeight: 600,
    color: colour.grey[100],
    marginLeft: 10,
    width: "100%",
    display: "block"
  },
  pastHour: {
    fontSize: 12,
    color: colour.grey[400],
    marginTop: 0,
    marginBottom: 8,
    marginLeft: 10
  },
  onHightlight: {
    color: "#FFFFFF",
    background: colour.brand.green,
    borderRadius: 10,
    padding: "0px 5px 1px",
    fontSize: 12,
    fontWeight: 600,
    marginTop: 5,
    textAlign: "center"
  }
});
